export default __webpack_public_path__ + "static/media/hht2_home_img_EP2.42a3f2b8.png";